module.exports = __webpack_public_path__ + "static/img/image15.c043407c.png";